import type { Mask } from '../data/v1'
import { useResolvedColor } from '../lib/use-resolved-color'

function hexToRgba(hex: string, opacity: number): string {
	const r = parseInt(hex.slice(1, 3), 16)
	const g = parseInt(hex.slice(3, 5), 16)
	const b = parseInt(hex.slice(5, 7), 16)
	return `rgba(${r},${g},${b},${opacity / 100})`
}

function SolidMaskFill({ mask }: { mask: Mask }) {
	const color = useResolvedColor(mask.solidColor)

	if (!color) { return null }

	return (
		<div
			className="absolute inset-0"
			style={{
				backgroundColor: color,
				opacity: mask.solidOpacity / 100,
				mixBlendMode: mask.blendMode,
			}}
		/>
	)
}

function GradientMaskFill({ mask }: { mask: Mask }) {
	const colorStart = useResolvedColor(mask.gradientColorStart)
	const colorEnd = useResolvedColor(mask.gradientColorEnd)

	if (!colorStart || !colorEnd) { return null }

	const start = hexToRgba(colorStart, mask.gradientOpacityStart)
	const end = hexToRgba(colorEnd, mask.gradientOpacityEnd)

	return (
		<div
			className="absolute inset-0"
			style={{
				background: `linear-gradient(${mask.gradientAngle}deg, ${start}, ${end})`,
				mixBlendMode: mask.blendMode,
			}}
		/>
	)
}

export type MaskFillProps = {
	mask: Mask
}

export function MaskFill({ mask }: MaskFillProps) {
	switch (mask.maskMode) {
		case 'none':
			return null
		case 'solid':
			return <SolidMaskFill mask={mask} />
		case 'gradient':
			return <GradientMaskFill mask={mask} />
	}
}
